var _rect, _rect2, _rect3, _g, _rect4, _rect5, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileMfaIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 12,
    width: 19.4468,
    height: 40.6614,
    rx: 2.65183,
    fill: "#166BCD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.1113,
    y: 13.625,
    width: 17.2243,
    height: 34.9909,
    rx: 2.30213,
    fill: "#7EB3F1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14186_170540",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 13,
    width: 18,
    height: 36
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.1113,
    y: 13.625,
    width: 17.2243,
    height: 34.9909,
    rx: 2.30213,
    fill: "#CEE6FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14186_170540)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M23.1113 13.625L35.6128 13.625L23.1113 31.8988V13.625Z",
    fill: "#CEE6FF"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27.2031,
    y: 49.8496,
    width: 9.25025,
    height: 1.32397,
    rx: 0.661986,
    fill: "#CEE6FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_14186_170540",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 13,
    width: 18,
    height: 36
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.1113,
    y: 13.625,
    width: 17.2243,
    height: 34.9909,
    rx: 1.90901,
    fill: "#CEE6FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_14186_170540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5502 21.4519C28.5502 22.4532 27.7384 23.265 26.737 23.265C25.7356 23.265 24.9238 22.4532 24.9238 21.4519C24.9238 20.4505 25.7356 19.6387 26.737 19.6387C27.7384 19.6387 28.5502 20.4505 28.5502 21.4519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5502 26.4381C28.5502 27.4395 27.7384 28.2513 26.737 28.2513C25.7356 28.2513 24.9238 27.4395 24.9238 26.4381C24.9238 25.4367 25.7356 24.6249 26.737 24.6249C27.7384 24.6249 28.5502 25.4367 28.5502 26.4381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5502 31.4243C28.5502 32.4257 27.7384 33.2375 26.737 33.2375C25.7356 33.2375 24.9238 32.4257 24.9238 31.4243C24.9238 30.4229 25.7356 29.6112 26.737 29.6112C27.7384 29.6112 28.5502 30.4229 28.5502 31.4243Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5502 36.4106C28.5502 37.412 27.7384 38.2238 26.737 38.2238C25.7356 38.2238 24.9238 37.412 24.9238 36.4106C24.9238 35.4092 25.7356 34.5974 26.737 34.5974C27.7384 34.5974 28.5502 35.4092 28.5502 36.4106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5364 21.4519C33.5364 22.4532 32.7246 23.265 31.7232 23.265C30.7219 23.265 29.9101 22.4532 29.9101 21.4519C29.9101 20.4505 30.7219 19.6387 31.7232 19.6387C32.7246 19.6387 33.5364 20.4505 33.5364 21.4519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5364 26.4381C33.5364 27.4395 32.7246 28.2513 31.7232 28.2513C30.7219 28.2513 29.9101 27.4395 29.9101 26.4381C29.9101 25.4367 30.7219 24.6249 31.7232 24.6249C32.7246 24.6249 33.5364 25.4367 33.5364 26.4381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5364 31.4243C33.5364 32.4257 32.7246 33.2375 31.7232 33.2375C30.7219 33.2375 29.9101 32.4257 29.9101 31.4243C29.9101 30.4229 30.7219 29.6112 31.7232 29.6112C32.7246 29.6112 33.5364 30.4229 33.5364 31.4243Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5364 36.4106C33.5364 37.412 32.7246 38.2238 31.7232 38.2238C30.7219 38.2238 29.9101 37.412 29.9101 36.4106C29.9101 35.4092 30.7219 34.5974 31.7232 34.5974C32.7246 34.5974 33.5364 35.4092 33.5364 36.4106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5364 41.3968C33.5364 42.3982 32.7246 43.21 31.7232 43.21C30.7219 43.21 29.9101 42.3982 29.9101 41.3968C29.9101 40.3954 30.7219 39.5836 31.7232 39.5836C32.7246 39.5836 33.5364 40.3954 33.5364 41.3968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5227 21.4519C38.5227 22.4532 37.7109 23.265 36.7095 23.265C35.7081 23.265 34.8963 22.4532 34.8963 21.4519C34.8963 20.4505 35.7081 19.6387 36.7095 19.6387C37.7109 19.6387 38.5227 20.4505 38.5227 21.4519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5227 26.4381C38.5227 27.4395 37.7109 28.2513 36.7095 28.2513C35.7081 28.2513 34.8963 27.4395 34.8963 26.4381C34.8963 25.4367 35.7081 24.6249 36.7095 24.6249C37.7109 24.6249 38.5227 25.4367 38.5227 26.4381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5227 31.4243C38.5227 32.4257 37.7109 33.2375 36.7095 33.2375C35.7081 33.2375 34.8963 32.4257 34.8963 31.4243C34.8963 30.4229 35.7081 29.6112 36.7095 29.6112C37.7109 29.6112 38.5227 30.4229 38.5227 31.4243Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5227 36.4106C38.5227 37.412 37.7109 38.2238 36.7095 38.2238C35.7081 38.2238 34.8963 37.412 34.8963 36.4106C34.8963 35.4092 35.7081 34.5974 36.7095 34.5974C37.7109 34.5974 38.5227 35.4092 38.5227 36.4106Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMfaIcon);
export default __webpack_public_path__ + "static/media/MobileMFAIcon.d9cd6b58a157ca3eef530cf42d4c8dd7.svg";
export { ForwardRef as ReactComponent };